import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  id: "country-list",
  class: "ConfigurationBlock"
}
const _hoisted_2 = {
  key: 0,
  class: "ConfigurationBlockList"
}
const _hoisted_3 = {
  key: 1,
  class: "ConfigurationBlockList"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Country = _resolveComponent("Country")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.visibleCountries.length)
      ? (_openBlock(), _createElementBlock("ul", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visibleCountries, (id) => {
            return (_openBlock(), _createBlock(_component_Country, {
              key: id,
              id: id
            }, null, 8 /* PROPS */, ["id"]))
          }), 128 /* KEYED_FRAGMENT */))
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, [...(_cache[0] || (_cache[0] = [
          _createElementVNode("p", { class: "NoCountriesFoundText" }, " No countries were found that match your search. ", -1 /* CACHED */)
        ]))]))
  ]))
}